import { render, staticRenderFns } from "./ProjectDocumentsTable.vue?vue&type=template&id=08022872&"
import script from "./ProjectDocumentsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports